<template lang="pug">
v-layout(v-if="projekt" row wrap)
  template
    v-flex(xs12 md3): v-card(min-height="100%"): v-card-text
      img.img-fluid.mx-a.d-block(:src="projekt.logo" v-if="projekt.logo")
      template(v-if="onlyProjectId")
        | {{projekt.name}}
      template(v-else)
        v-autocomplete(label="Projekt" v-model="projektId" :items="projekte" item-text="nameMitAs" item-value="id" hide-details)

    v-flex(xs12 md3): v-card(min-height="100%"): v-card-text
      | {{projekt.name}}<br>
      | {{projekt.standort.strasse}} {{projekt.standort.hausnummer}}<br>
      | {{projekt.standort.plz}} {{projekt.standort.ort}}<br>
      br
      template(v-if="projekt.telefonDe")
        | Tel.: {{projekt.telefonDe}}<br>
      template(v-if="projekt.faxDe")
        | Fax: {{projekt.faxDe}}<br>
      template(v-if="projekt.email")
        | E-Mail: {{projekt.email}}<br>
      template(v-if="projekt.website")
        | Web: <a :href="httpIfy(projekt.website)">{{projekt.website}}</a><br>

    v-flex(xs12 md3): v-card(min-height="100%"): v-card-text
      template(v-for="anbieter in projekt.standort && projekt.standort.itAnbieter")
        v-layout(wrap)
          v-flex(v-if="anbieter.logo"): img.img-fluid.pull-left( :src="anbieter.logo")
          v-flex
            | {{anbieter.name}}<br>
            template(v-if="anbieter.telefon")
              | Tel.: {{anbieter.telefon}}<br>
            template(v-if="anbieter.email")
              | {{anbieter.email}}<br>
      template(v-if="projekt.standort.bandbreiteAktuell")
        | B.b. Atkuell: {{projekt.standort.bandbreiteAktuell}}<br>
      template(v-if="projekt.standort.bandbreiteMax")
        | B.b. Max: {{projekt.standort.bandbreiteMax}}<br>
      | VPN: {{projekt.vpnStatus ? 'Online' : projekt.vpnStatus === false ? 'Offline' : 'Unbekannt' }}, NAS: {{projekt.standort.nas ? 'Ja' : 'Nein'}}<br>
      | IP: {{projekt.subnetz}}, {{projekt.publicIp}}

    v-flex(xs12 md3)

  v-flex(xs12): v-card: v-card-text
    v-tabs
      v-tab Mitarbeiter
      v-tab-item
        v-data-table(:items="personen" :headers="mitarbeiterHeader" must-sort :pagination.sync="mitarbeiterPagination")
          template(v-slot:items="{ item }")
            td: .user-thumb-round(v-if="item.foto" :style="`background-image: url(${item.foto})`")
            td {{ item.pronouns }}
            td {{ item.vorname }}
            td {{ item.nachname }}
            td {{ item.email }}
            td {{ item.lizenzen.join(", ") }}

      v-tab Tickets
      v-tab-item
        v-layout
          v-flex(xs12 sm9)
          v-flex(xs12 sm3): v-select(label="Status" v-model="status" :items="statuse")
        v-data-table(:items="tickets" :headers="ticketsHeader" must-sort :pagination.sync="ticketsPagination")
          template(v-slot:items="{ item }")
            td
              template(v-if="item.apiToken")
                a(:href="`/it-ticketbox?ticketId=${item.id}&ticketToken=${item.apiToken}`") {{ item.id }}
              template(v-else) {{item.id}}
            td {{ item.betreff }}
            td {{ item.bearbeiter && item.bearbeiter.vollerName }}
            td {{ item.statusHuman }}

      v-tab Computer
      v-tab-item
        v-data-table(:items="agents" :headers="agentsHeader" must-sort :pagination.sync="agentsPagination")
          template(v-slot:items="{ item }")
            td: v-icon {{ batterie[item.agentName] ? 'laptop' : batterie[item.agentName] === false ? 'desktop_windows' : 'help_outline' }}
            td {{ item.agentName }}
            td {{ item.userProfiles.join(', ') }}
            td {{ item.motherboard }}
            td {{ item.modellName }}
            td {{ item.modellSerial }}
            td {{ bitlocker[item.agentName] ? 'Ja' : '' }}
            td
              template(v-for="hdd in hdds[item.agentName]")
                div {{hdd.modell}} {{hdd.serial}} ({{hdd.groesse}})

      v-tab Mobilfunk
      v-tab-item
        v-data-table(:items="vertraege" :headers="vertraegeHeader" must-sort :pagination.sync="vertraegePagination")
          template(v-slot:items="{ item }")
            td {{ item.rufnummer }}
            td {{ item.person && item.person.vollerName }}
            td {{ item.kuendigungsfrist }}

      v-tab Monitore
      v-tab-item
        v-data-table(:items="monitore" :headers="monitoreHeader" must-sort :pagination.sync="monitorePagination")
          template(v-slot:items="{ item }")
            td {{ item.hersteller }}
            td {{ item.modell }}
            td {{ item.serial }}

      v-tab Drucker
      v-tab-item
        v-data-table(:items="drucker" :headers="druckerHeader" must-sort :pagination.sync="druckerPagination")
          template(v-slot:items="{ item }")
            td {{ item.name }}
            td {{ item.port }}
            td {{ item.driver }}

      v-tab Netzlaufwerke
      v-tab-item
        v-data-table(:items="laufwerke" :headers="laufwerkeHeader" must-sort :pagination.sync="laufwerkePagination")
          template(v-slot:items="{ item }")
            td {{ item.destination }}

      v-tab Software
      v-tab-item
        v-data-table(:items="softwareList" :headers="softwareHeader" must-sort :pagination.sync="softwarePagination")
          template(v-slot:items="{ item }")
            td {{ item.name }}
            td {{ item.publisher }}
            td {{ item.allowed }}
            td {{ item.pcs.map(pc => pc.name).join(", ") }}

      v-tab Ausleihe
      v-tab-item    
        v-data-table(:items="personenMitAusleihe" :headers="ausleiheHeader" must-sort :pagination.sync="ausleihePagination")
          template(v-slot:items="{ item }")
            template(v-for="ausleihe in item.ausleihen")
              td {{ ausleihe.id }}
              td {{ item.vorname}}
              td {{ item.nachname}}
              td {{ ausleihe.hardware }}
              td {{ ausleihe.anzahl }}
              td {{ ausleihe.ausgeliehenAm }}
              td {{ ausleihe.geplanteAbgabe }}
              td {{ ausleihe.abgegebenAm }}

v-layout(v-else)
  v-flex(xs12): v-card: v-card-text Keine Projekte Vorhanden

</template>

<style lang="stylus" scoped>
.user-thumb-round
  border-radius 50%
  width 40px
  height 40px

</style>

<script>
import gql from 'graphql-tag'
import { menus, user } from '../router'
import { flatMap, sortBy, countBy, uniq, uniqBy } from 'lodash'

export default {
  props: ['extra', 'onlyProjectId'],
  name: 'mein-projekt',
  data() {
    return {
      projekt: null,
      projektId: null,
      softwareListAll: [],
      status: 'neu',
      statuse: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Geschlossen', value: 'geschlossen' },
      ],
      ticketsHeader: [
        { text: 'ID', value: 'id' },
        { text: 'Betreff', value: 'betreff' },
        { text: 'Bearbeiter', value: 'bearbeiter.vollerName' },
        { text: 'Status', value: 'statusHuman' },
      ],
      ticketsPagination: {
        descending: true,
        rowsPerPage: 5,
        sortBy: 'id'
      },
      agentsHeader: [
        { text: 'Art', sortable: false },
        { text: 'Name', value: 'agentName' },
        { text: 'User', value: 'userProfiles' },
        { text: 'Hersteller', value: 'motherboard' },
        { text: 'Model', value: 'modellName' },
        { text: 'Serial', value: 'modellSerial' },
        { text: 'Bitlocker', sortable: false },
        { text: 'HDD/SSD', sortable: false }
      ],
      agentsPagination: {
        sortBy: 'agentName'
      },
      vertraegeHeader: [
        { text: 'Rufnummer', value: 'rufnummer' },
        { text: 'Name', value: 'person.vollerName' },
        { text: 'Kündigungsfrist', value: 'kuendigungsfrist' },
      ],
      vertraegePagination: {
        sortBy: 'rufnummer'
      },
      mitarbeiterHeader: [
        { text: '', sortable: false },
        { text: 'Pronouns', value: 'pronouns' },
        { text: 'Vorname', value: 'vorname' },
        { text: 'Nachname', value: 'nachname' },
        { text: 'E-Mail', value: 'email' },
        { text: 'Lizenzen', value: 'lizenzen' },
      ],
      mitarbeiterPagination: {
        sortBy: 'nachname'
      },
      laufwerkeHeader: [
        { text: 'Netzlaufwerk', value: 'destination' },
      ],
      laufwerkePagination: {
        sortBy: 'destination'
      },
      druckerHeader: [
        { text: 'Name', value: 'name' },
        { text: 'Anschluss', value: 'port' },
        { text: 'Art', value: 'driver' },
      ],
      druckerPagination: {
        sortBy: 'name'
      },
      softwarePagination: {
        sortBy: 'name'
      },
      ausleihePagination: {
        sortBy: 'nachname'
      },
      softwareHeader: [
        { text: 'Softwarename', value: 'name' },
        { text: 'Softwarehersteller', value: 'publisher' },
        { text: 'Erlaubt', value: 'allowed' },
        { text: 'Computer', sortable: false },
      ],
      ausleiheHeader: [
        { text: 'ID', value: 'id' },
        { text: 'Vorname', value: 'vorname' },
        { text: 'Nachname', value: 'nachname' },
        { text: 'Hardware', value: 'hardware' },
        { text: 'Anzahl', value: 'anzahl' },
        { text: 'Ausgeliehen am', value: 'ausgeliehen_am' },
        { text: 'Geplante Abgabe', value: 'geplante_abgabe' },
        { text: 'Abgegeben am', value: 'abgegeben_am' },
      ],
      monitoreHeader: [
        { text: 'Hersteller', value: 'hersteller' },
        { text: 'Modell', value: 'modell' },
        { text: 'Serial', value: 'serial' },
      ],
      monitorePagination: {
        sortBy: 'modell'
      },
      ateraCollection: [],
      alleProjekte: [],
      personen: [],
      user
    }
  },
  apollo: {
    projektDetails: {
      query: gql`query ExtraMeinProjektDetails($id: ID) {
        projektDetails: projekte(where: { id: $id }) {
          id
          name
          logo(size: "200x100")
          telefonDe
          website
          email
          abteilung
          faxDe
          subnetz
          publicIp
          vpnStatus
          ateraAgents {
            id
            agentName
            userProfiles
            motherboard
            modellName
            modellSerial
            ipAddresses
            ipAddressRemote
            updatedAt
          }
          standort {
            id
            strasse
            hausnummer
            plz
            ort
            email
            tel
            aussenstelle
            bandbreiteAktuell
            bandbreiteMax
            ip
            vpn
            nas
            itAnbieter {
              id
              name
              logo(size: "200x100")
              telefon
              email
            }
          }
          itTickets {
            id
            status
            betreff
            statusHuman
            apiToken
            bearbeiter {
              id
              vollerName
            }
          }
          telekommunikationsvertraege {
            id
            rufnummer
            kuendigungsfrist
            person {
              id
              vollerName
            }
          }
          anbieter {
            id
            logo(size: "200x100")
            name
            telefon
          }
        }
      }`,
      variables() {
        return {
          id: this.onlyProjectId || this.projektId
        }
      },
      skip() {
        return !this.onlyProjectId && !this.projektId
      }
    },
    alleProjekte: {
      query: gql`query ExtraMeinProjektAlleProjekte {
        alleProjekte: projekte {
          id
          name
          abteilung
          standort {
            id
            aussenstelle
          }
        }
      }`
    },
    currentUser: {
      query: gql`query ExtraMeinProjektCurrentUser {
        currentUser {
          id
          person {
            id
            projekte {
              id
              abteilung
            }
          }
        }
      }`
    },
    softwareListAll: {
      query: gql`query ExtraMeinProjektCurrentUser {
        softwareListAll: softwareLists {
          id
          name
          publisher
          allowed
          pcs {
            id
            name
          }
          personenProjektIds
        }
      }`
    },
    ateraCollection: {
      query: gql`query ExtraMeinProjektAteraCollection($projektId: ID) {
        ateraCollection(projektId: $projektId) {
          id
          name
          pc
          battery
          bitlocker
          laufwerke {
            path
            destination
          }
          drucker {
            name
            port
            driver
          }
          monitore {
            modell
            hersteller
            serial
          }
          hdds {
            modell
            groesse
            serial
          }
        }
      }`,
      variables() {
        return {
          projektId: this.onlyProjectId || this.projektId
        }
      },
      skip() {
        return !this.onlyProjectId && !this.projektId
      }
    },
    personen: {
      query: gql`query ExtraMeinProjektAteraCollection($q: String) {
        personen(q: $q, where: { art: "mitarbeiter", status: "angestellt" }) {
          vorname
          nachname
          pronouns
          email
          foto(size: "40x40#")
          lizenzen
          ausleihen {
            id
            hardware
            anzahl
            ausgeliehenAm
            geplanteAbgabe
            abgegebenAm
          }
        }
      }`,
      variables() {
        return {
          q: JSON.stringify({ projekte_id_eq: this.onlyProjectId || this.projektId })
        }
      },
      skip() {
        return !this.onlyProjectId && !this.projektId
      }
    }
  },
  watch: {
    projektDetails(projekte) {
      if (this.user && this.user.person && this.user.person.vorstand || this.user.person.bereichsleitung || this.user.person.abteilungsleitung || this.user.person.projektleitung || this.user.person.ticketBearbeiter) {
        const projekt = projekte && projekte[0] && projekte[0] || {}
        this.projekt = { ...projekt, standort: projekt.standort || {} }
      }
    },
    projekte(projekte) {
      this.projektId = projekte && projekte[0] && (projekte.find((p) => /KdöR/.test(p.name)) || projekte[0]).id
    }
  },
  computed: {
    personenMitAusleihe() {
      return this.personen.filter(p => p.ausleihen.length)
    },
    projekte() {
      let projekte = []
      const person = this.user && this.user.person || {}
      if (person.ticketBearbeiter || person.vorstand) {
        projekte = this.alleProjekte
      } else if (person.abteilungsleitung || person.bereichsleitung) {
        const abts = uniq(this.currentUser && this.currentUser.person && this.currentUser.person.projekte || []).map((p) => p.abteilung)
        projekte = this.alleProjekte.filter((p) => abts.indexOf(p.abteilung) > -1)
      } else if (person.projektleitung) {
        const pids = (this.currentUser && this.currentUser.person && this.currentUser.person.projekte || []).map((p) => p.id)
        projekte = this.alleProjekte.filter((p) => pids.indexOf(p.id) > -1)
      }
      projekte = projekte.filter((p) => !/ARCHIV/.test(p.name))
      return sortBy(projekte.map((projekt) => {
        return {
          ...projekt,
          standort: projekt.standort || {},
          nameMitAs: `${projekt.standort && projekt.standort.aussenstelle || ''} ${projekt.name}`
        }
      }), 'nameMitAs')
    },
    agents() {
      return this.projekt && this.projekt.ateraAgents || []
    },
    tickets() {
      const status = this.status
      const tickets = this.projekt && this.projekt.itTickets || []
      if (status === 'geschlossen') {
        const statuse = ['neu', 'in_bearbeitung', 'erledigt']
        return tickets.filter((t) => statuse.indexOf(t.status) < 0)
      } else {
        return tickets.filter((t) => t.status === status)
      }
    },
    vertraege() {
      return this.projekt && this.projekt.telekommunikationsvertraege || []
    },
    batterie() {
      const batterie = {}
      this.ateraCollection.filter((a) => a.name === 'Battery').forEach((a) => {
        batterie[a.pc] = a.battery
      })
      return batterie
    },
    bitlocker() {
      const bitlocker = {}
      this.ateraCollection.filter((a) => a.name === 'BitlockerID').forEach((a) => {
        bitlocker[a.pc] = a.bitlocker
      })
      return bitlocker
    },
    hdds() {
      const hdds = {}
      this.ateraCollection.filter((a) => a.name === 'HDD/SSD').forEach((a) => {
        hdds[a.pc] = a.hdds
      })
      return hdds
    },
    laufwerke() {
      return sortBy(uniqBy(flatMap(this.ateraCollection.filter((a) => a.name === 'Laufwerke'), (a) => a.laufwerke).filter((a) => a.destination).map((a) => ({ destination: a.destination })), 'destination'), 'destination')
    },
    drucker() {
      return uniqBy(flatMap(this.ateraCollection.filter((a) => a.name === 'Drucker'), (d) => d.drucker), 'name')
    },
    monitore() {
      return uniqBy(flatMap(this.ateraCollection.filter((a) => a.name === 'Monitor'), (d) => d.monitore), JSON.stringify)
    },
    softwareList() {
      const agents = this.agents
      const projektId = this.onlyProjectId || this.projektId
      return this.softwareListAll.filter((s) => s.personenProjektIds.some((p) => p == projektId) || s.pcs.some((pc) => agents.some((a) => a.agentName === pc.name)))
    }
  },
  methods: {
    httpIfy(url) {
      if (/^(\/|https?:\/\/)/.test(url)) {
        return url
      } else {
        return `http://${url}`
      }
    },
  }
}
</script>
